export type DateOnlyValue = Date | string | null | undefined;

const dateOnlyPattern = /^(\d{4})-(\d{2})-(\d{2})(?:$|T)/;
const pad = (value: number) => String(value).padStart(2, "0");

/** Serialize a calendar date without converting it through UTC. */
export function toDateOnlyString(value: DateOnlyValue): string | null {
  if (!value) return null;
  if (typeof value === "string") {
    const match = value.match(dateOnlyPattern);
    return match && fromDateOnlyString(value) ? `${match[1]}-${match[2]}-${match[3]}` : null;
  }
  if (Number.isNaN(value.getTime())) return null;

  return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
}

/** Parse YYYY-MM-DD as a local calendar date rather than UTC midnight. */
export function fromDateOnlyString(value: string | null | undefined): Date | null {
  const match = value?.match(dateOnlyPattern);
  if (!match) return null;

  const [, year, month, day] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));

  return date.getFullYear() === Number(year) &&
    date.getMonth() === Number(month) - 1 &&
    date.getDate() === Number(day)
    ? date
    : null;
}
